(function() {
  const initProductSlider = () => {
    const product_sliders = document.querySelectorAll('.carousel__slider_sus');
    product_sliders.forEach((slider, index) => {

      const productSlider = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        simulateTouch: true, 
        autoHeight: true,
        speed: 500,
        navigation: {
          nextEl: ".carousel__slider-nav .swiper-button-next",
          prevEl: ".carousel__slider-nav .swiper-button-prev",
        },
      })
    })
  }
  initProductSlider();
})()